<template>
  <div class="head-item">
    <div class="head-click c-c van-hairline--bottom">
      <div class="bt van-hairline--surround radiusStyle" @click="down()">
        下架
      </div>
      <div
        v-if="mes.is_recommend == 1"
        class="grey bt van-hairline--surround radiusStyle"
      >
        刷新
      </div>
      <div
        v-if="mes.is_recommend !== 1"
        class="bt van-hairline--surround radiusStyle"
        @click="refresh()"
      >
        刷新
      </div>
      <div
        v-if="mes.is_recommend == 1"
        class="grey bt van-hairline--surround radiusStyle"
      >
        置顶中
      </div>
      <div
        v-if="mes.is_recommend !== 1"
        class="bt van-hairline--surround radiusStyle"
        @click="up()"
      >
        置顶
      </div>
      <div
        v-if="mes.can_sync == 1 && mes.is_sync == 0"
        style="width: auto"
        class="bt van-hairline--surround radiusStyle"
        @click="sameShop()"
      >
        同步到店铺
      </div>
      <div
        v-if="mes.can_sync == 1 && mes.is_sync == 1"
        style="width: auto; color: gray"
        class="bt van-hairline--surround radiusStyle"
      >
        已在店铺
      </div>
    </div>
    <div class="main-mes van-hairline--bottom">
      <span
        class="t-l c-l f15"
        style="width: 100%;white-space: break-spaces;"
        @click="toggleShow(mes.content)"
        v-toggleContent
        ><span v-if="mes.is_refresh == '1'" style="color: rgb(137, 39, 133);">【精选】</span>{{ content }}</span
      >
    </div>
    <div class="c-c head-item-bottom">
      <div class="c-l flex1 f11 one-hour">更新:{{ mes.published_time }}</div>
      <div class="flex1 c-c">
        <div
          class="man-pic"
          v-for="(item, index) in pics"
          :key="index"
          @click="previewPic(index)"
        >
          <img :src="item" alt />
        </div>
      </div>
      <!--不可点击-->
      <template v-if="mes.is_recommend !== 1">
        <template v-if="mes.super_recommend == 0">
          <div
            v-if="mes.super_id"
            class="CJTJ"
            style="background-color: #bfbfbf"
            @click="setSuperRec(mes.id, 1)"
          >
            <img src="../assets/images/images/shadowGray.png" />
            <div style="justify-content: center; color: #fff">超级推荐</div>
          </div>
          <div v-else class="CJTJ" @click="setSuperRec(mes.id, 1)">
            <img src="../assets/images/images/rocketPic.png" />
            <div style="justify-content: center; color: #fff">超级推荐</div>
          </div>
        </template>
        <div class="CJTJ" v-else @click="setSuperRec(mes.id, 2)">
          <img src="../assets/images/images/rocketPic.png" />
          <div style="justify-content: center; color: #fff">取消超推</div>
        </div>
      </template>

      <div v-if="showClose" class="closeImgStyle">
        <img
          @click="closeImg"
          style="width: 30px; height: 30px"
          src="../assets/images/images/close.png"
          alt
        />
      </div>
      <div @click="warn()" class="c-end flex1 f11 one-hour"></div>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <div class="pp">
      <van-image-preview
        v-model="showPreview"
        :images="images"
      ></van-image-preview>
    </div>

    <!--提示弹窗-->
    <van-popup v-model="showTips" class="tipsTC">
      <div class="showTips">
        <div class="closeTc">
          <img
            src="../assets/images/images/closeTC.png"
            alt=""
            @click="closePayTc"
          />
        </div>
        <!--tips-->
        <div class="tips">
          <div class="tipsTop">
            <img src="../assets/images/images/successInfo.png" alt="" />
            开通包周畅刷服务，增加曝光，加速成交！
          </div>
          <div class="tipsMiddle">
            此服务共包含{{
              mounthNum
            }}次VIP刷新权限，信息刷新后能靠前显示，用户可在“我的发布”里自行操作！
          </div>
          <div class="tipsBottom">
            （注:每天最多刷新{{ dataNum }}次,7天内使用完）
          </div>
        </div>
        <div class="selectPrice">
          <div>
            <img
              v-if="hasSelect"
              src="../assets/images/images/select.png"
              alt=""
              @click="changeSelectStatus"
            />
            <img
              v-else
              src="../assets/images/images/closeSelect.png"
              alt=""
              @click="changeSelectStatus"
            />
          </div>
          <div class="priceSec">
            <span>VIP刷新体验价仅</span
            ><span>{{ moneyInfo.fee / 100 }}元/周</span>
          </div>
        </div>
        <!--确认支付-->
        <div class="prePay">
          <div v-if="hasSelect" class="submitPay" @click="prePayMoney">
            确认支付
          </div>
          <div v-else class="submitPay noSelect">确认支付</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
let instance;
let me;
import { ActionSheet } from "vant";
import { Dialog } from "vant";
import { ImagePreview } from "vant";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
export default {
  name: "HeadItemThree",
  data() {
    return {
      showClose: false,
      showDrawUp: false,
      show: false,
      actions: [],
      showPreview: false,
      realSmallImages: [],
      realImages: [],
      images: [],

      showTips: false,
      hasSelect: true,
      vipStatus: {}, //当前用户是否已开通vip，0：未开通，1：已开通
      dataNum: 0, //每天刷新的次数
      mounthNum: 0, //每月刷新的次数
      dayLimit: 0, //每天刷新次数限制
      mounthLimit: 0, //每月刷新次数限制
      moneyInfo: {}, //付款信息
    };
  },
  computed: {
    content() {
      return this.mes.content;
    },
    pics() {
      if (this.mes.thumbs.length != 0) {
        this.realImages = [];
        this.realSmallImages = [];
        for (let a = 0; a < this.mes.thumbs.length; a++) {
          this.realImages.push(this.mes.thumbs[a].path_url);
          this.realSmallImages.push(this.mes.thumbs[a].small_path_url);
        }
        this.images = this.realImages;
        return this.realSmallImages.slice(0, 3);
      } else {
        // return this.images;
      }
    },
  },
  methods: {
    //尚未开通超级会员，跳转超级会员充值页面
    jumpSuperVip() {
      me.$router.push({
        path: "superVip",
      });
    },
    //设置/取消超级推荐
    setSuperRec(messageId, type) {
      Dialog.confirm({
        title: `确定${type == 1 ? "" : "取消"}超级推荐吗？`,
        message: `${type == 1 ? '（其他“超推”中的信息将取消）':'' }`,
      })
        .then((res2) => {
          postData("/user/message-super", {
            messageId: messageId,
            type: type,
          })
            .then((res) => {
              if(res.code == 0) {
                me.$emit("ReGetInfo");
              } else if (res.code == 1 && res.data.error_code == 3) {
                me.jumpSuperVip();
              } else if (res.code == 1 && res.data.error_code != 3) {
                me.$toast(res.data.error_msg);
              }
            })
            .catch((err) => {
            });
        })
        .catch((err) => {});
    },
    //改变勾选状态
    changeSelectStatus() {
      me.hasSelect = !me.hasSelect;
    },
    //获取每日和每月刷新数
    getDayAndMounthCount() {
      getData("/vip/refresh-num")
        .then((res) => {
          if (res.code == "0") {
            me.dataNum = res.data.day_refresh_num; //每日数量
            me.mounthNum = res.data.month_refresh_num; //每月数量
          }
        })
        .catch((err) => {});
    },
    //获取刷新剩余数量
    getLeaveRefreshNum() {
      return new Promise(function (resolve, reject) {
        getData("/vip/user-refresh-num")
          .then((res) => {
            me.dayLimit = res.data.day_remain; //每日数量
            me.mounthLimit = res.data.month_remain; //每月数量
            resolve(res);
          })
          .catch((err) => {
            reject();
          });
      });
    },
    //获取VIP刷新体验价格
    getVipPrice() {
      getData("/vip/user-ob")
        .then((res) => {
          me.moneyInfo = res.data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取用户当前的开通状态
    getUserStatus() {
      return new Promise(function (resolve, reject) {
        postData("/vip/is-pay", {
          type: "user",
        })
          .then((res) => {
            me.vipStatus = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            console.log(err);
            resolve();
          });
      });
    },
    //确认支付
    prePayMoney() {
      postData("/payment/order/create", {
        trade_type: "mp",
        plan_id: me.moneyInfo.id,
      })
        .then((res) => {
          me.onBridgeReady(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //调起微信支付
    onBridgeReady(msg) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", msg, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        }
      });
    },
    //关闭弹窗
    closePayTc() {
      this.showTips = false;
    },

    closeImg() {
      this.showClose = false;
      if (instance) {
        instance.close();
      }
    },
    //同步到我的店铺
    sameShop() {
      postData(
        "/user/sync-message",
        { message_id: this.mes.id },
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      ).then((res) => {
        if (res.code == 0) {
          this.$toast("同步成功");
          setTimeout(() => {
            this.$emit("ReGetInfo");
          }, 500);
        } else {
          this.$toast("同步失败");
        }
      });
    },
    previewPic(index) {
      this.showClose = true;
      instance = ImagePreview({
        images: this.images,
        asyncClose: true,
        startPosition: index,
      });
    },
    onSelect(item) {
      // 点击选项时默认不会关闭菜单，可以手动关闭
      this.show = false;
      // Toast(item.name);
    },
    getList() {
      getData("/recommend-lists", {}).then((res) => {});
    },
    toggleShow(index) {},
    warn() {
      this.show = true;
    },
    close() {
      this.showDrawUp = false;
    },
    down() {
      Dialog.confirm({
        // title: "下架",
        message: "确定下架吗？",
      })
        .then(() => {
          // on confirm
          postData(
            "/user/ban-message",
            { message_id: this.mes.id },
            {
              headers: {
                token: localStorage.getItem("token"),
              },
            }
          ).then((res) => {
            this.$toast("下架成功");
            setTimeout(() => {
              this.$emit("ReGetInfo");
            }, 500);
          });
        })
        .catch(() => {
          // on cancel
        });
      return;
    },
    up() {
      this.$toast("置顶服务需联系客服开通");
    },
    //用户点击刷新
    refresh() {
      let me = this;
      if(me.mes.is_recommend == 1) {
        this.$toast("已置顶不可刷新");
        return;
      }
      if(me.mes.super_recommend != 0) {
        this.$toast("已超推不可刷新");
        return;
      }
      me.getUserStatus().then((res) => {
        // if(!res) {
        //   me.$toast("商户未开通门店!");
        //   return;
        // }
        if (res && res.type == "on") {
          //用户已经购买过
          me.getLeaveRefreshNum().then((res) => {
            if (res.data.month_remain <= 0) {
              //本月已超
              me.$toast("本周刷新权限已 用完，请下周购买!");
            } else if (res.data.day_remain <= 0) {
              //本日已超
              me.$toast("今日刷新权限 已用完!");
            } else {
              me.doRefresh();
            }
          });
        } else {
          me.$emit("showTipsTC");
        }
      });
    },
    doRefresh() {
      Dialog.confirm({
        message: "确定刷新吗？",
      })
        .then(() => {
          postData("/user/refresh-message", { message_id: this.mes.id })
            .then((res) => {
              if (res.code == "0") {
                let dayUsed = res.data.day_used;
                let mounthUsed = res.data.month_used;
                if (res.data.vip_type != 1) {
                  this.$toast(`今日剩余${me.dataNum - dayUsed}次`);
                } else {
                  this.$toast(`刷新成功，剩余${me.mounthNum - mounthUsed}次`);
                }

                setTimeout(() => {
                  me.$emit("ReGetInfo");
                }, 500);
              } else {
                me.$toast(res.data.msg);
              }
            })
            .catch((err) => {
              me.$toast(err.data.msg);
            });
        })
        .catch(() => {});
    },
  },
  props: {
    mes: {
      type: Object,
      default: {},
    },
    downInfo: {
      type: Boolean,
      default: false,
    },
    refreshInfo: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    me = this;
    me.getDayAndMounthCount();
    me.getVipPrice();
    if (me.downInfo) {
      //下架贴子
      me.down();
    } else if (me.refreshInfo) {
      //刷新贴子
      me.refresh();
    }
  },
  beforeDestroy() {
    this.closeImg();
  },
};
</script>

<style scoped>
.closeImgStyle {
  position: fixed;
  bottom: 100px;
  left: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 9999;
}
.CJTJ {
  position: absolute;
  right: 5px;
  font-size: 13px;
  display: flex;
  align-items: center;
  padding: 2px 5px;
  border-radius: 10px;
  background-color: #882784;
}
.CJTJ img {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.head-click {
  height: 35px;
}
.head-click .bt {
  width: 61px;
  height: 23px;
  font-size: 15px;
  margin-left: 7px;
  color: rgb(77, 77, 77);
  border-radius: 5px;
}
.head-item {
  width: 100%;
  /* height:343px; */
  background: #fff;
  margin-top: 3px;
  padding: 8px 12px 0px 16px;
  margin-top: 7px;
  box-sizing: border-box;
  border-radius: 5px;
}
.head-item-top {
  width: 100%;
  margin-top: 10px;
}
.phone {
  width: 20px;
  height: 20px;
}
.man-pic {
  width: 34px;
  height: 34px;
  margin-right: 5px;
  overflow: hidden;
  position: relative;
}
.man-pic img {
  width: auto !important;
  height: auto !important;
  max-width: 3rem;
  min-height: 34px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.head-item-bottom {
  height: 45px;
  position: relative;
}
.main-mes {
  font-size: 12px;
  color: rgb(51, 51, 51);
  padding: 13px 0 12px 0;
}
.one-hour {
  color: rgb(143, 143, 143);
}
.main-pic {
  width: 29px;
  height: 29px;
}
.main-tag {
  margin-left: 4px;
}
.t128 {
  color: rgb(128, 128, 128);
  margin-top: 3px;
  width: 7rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tag-small div {
  width: 13px;
  height: 13px;
  margin-right: 3px;
}
.Sh {
  display: block;
}
.Hi {
  display: none;
}

/**支付预弹窗 */
.tips {
  background-color: #e7d4e6;
  margin: 0px 10px 10px 10px;
  border-radius: 5px;
  padding: 5px 5px;
}
.tipsTop {
  font-size: 13px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #882784;
}
.tipsTop img {
  width: 20px;
  height: 20px;
}
.tipsMiddle {
  font-size: 13px;
  margin-top: 5px;
  text-align: left;
  color: #696969;
}
.tipsBottom {
  text-align: left;
  font-size: 13px;
  color: #696969;
}
.selectPrice {
  display: flex;
  justify-content: center;
  align-items: center;
}
.selectPrice > div:nth-child(1) {
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.selectPrice img {
  width: 20px;
  height: 20px;
}
.priceSec {
  font-weight: bold;
  color: #882784;
  font-size: 20px;
}
.priceSec > span:nth-child(2) {
  font-weight: bolder;
  font-size: 23px;
}
.submitPay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 5px 110px;
  border-radius: 5px;
  background-color: #882784;
  height: 30px;
  color: #fff;
}
.noSelect {
  background-color: #cbcbcb;
}
.prePay {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.closeTc {
  text-align: right;
}
.closeTc img {
  width: 25px;
  height: 25px;
  margin-top: 5px;
  margin-right: 5px;
}
.tipsTC {
  border-radius: 5px;
}
.showTips {
  width: 320px;
  height: fit-content;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
.radiusStyle {
  border-radius: 10px;
  border: 1px solid #bdbdbd;
  padding: 0px 2px;
}
</style>
